
const apiUrl = process.env.REACT_APP_API_URL;

export const generate_Id = () => {
    const now = new Date();
    const year = String(now.getFullYear()).slice(2); // last 2 digits
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const datePart = `${month}${day}${year}`; // e.g., "250719"
    const randomPart = Math.floor(100000 + Math.random() * 900000); // always 6 digits

    return `CMT${datePart}${randomPart}`; // e.g., "CMT250719312344"
};

export const get_Customer_Id = async () => {
    let customerId;
    let isUnique = false;

    while (!isUnique) {
        customerId = generate_Id();

        try {
            const response = await fetch(`${apiUrl}validation/validate_customer_id.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId }),
            });

            const data = await response.json();
            isUnique = data.unique;

        } catch (error) {
            console.error('Error validating order number:', error);
            break;
        }
    }

    return customerId;
};